// Tooltip.jsx
import { useState, useEffect, useRef } from "react";

const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setShow(false);
      }
    };
    if (show) document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [show]);

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-block" }}>
      {show && (
        <div style={{
          position: "absolute",
          bottom: "125%",
          left: "50%",
          transform: "translateX(-50%)",
          backgroundColor: "#333",
          color: "#fff",
          padding: "6px 10px",
          borderRadius: "4px",
          fontSize: "12px",
          whiteSpace: "nowrap",
          zIndex: 1000,
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        }}>
          {text}
          <div style={{
            position: "absolute",
            top: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            borderWidth: "5px",
            borderStyle: "solid",
            borderColor: "#333 transparent transparent transparent",
          }} />
        </div>
      )}
      <div onClick={() => setShow(!show)} style={{ cursor: "pointer" }}>
        {children}
      </div>
    </div>
  );
};

export default Tooltip;